import palette from "../palette";

export default {
    day:{
        color: palette.darkGrey,
    }
}